// Used in thirdparty-general.js, so export everything globally
/* eslint-disable no-undef,no-global-assign */
// noinspection JSConstantReassignment

// See UserCookieService.java for a list of values included in the userId cookie

window.resetUserVariables = function () {
    // Keep the variables declared here in sync with globals.d.ts
    // legacy variables
    window.userId = '';
    window.userName = '';
    window.userHash = '';
    window.userType = '';
    window.userHasProjectRefundChoices = '';
    window.userHasPendingCheckPledges = '';

    // recommended
    window.userObj = {};
};

/**
 * This is used by several functions in favoritesStorage.ts, but it's also needed here.
 */
window.favCache = {};

/**
 * This arguably fits better in favoritesStorage.ts, but it needs to be included in the general.js build
 * so setUpUserCookies() can call it. setUpUserCookies() is called immediately on general.js load.
 */
window.removeFavorites = function () {
    eraseCookie('favProposalIds');
    eraseCookie('favChallengeIds');
    eraseCookie('favDonorIds');
    eraseCookie('favTeacherIds');
    eraseCookie('favSchoolIds');
    eraseCookie('favSearchURLs');
    eraseCookie('myGPs');
    eraseCookie('hasViewableGPs');
    eraseCookie('favCookiesSet');

    window.favCache = {};

    dcLocalStorage.setValue('favProposalIds', '[]');
    dcLocalStorage.setValue('favChallengeIds', '[]');
    dcLocalStorage.setValue('favDonorIds', '[]');
    dcLocalStorage.setValue('favTeacherIds', '[]');
    dcLocalStorage.setValue('favSchoolIds', '[]');
    dcLocalStorage.setValue('favSearchURLs', '[]');
    dcLocalStorage.setValue('myGPs', '[]');

    $(document).trigger('removeFavorites');
};

window.setUpUserCookies = function () {
    resetUserVariables();
    if (isNonBlankCookie('userId')) {
        const userCookie = readCookie('userId');
        try {
            const decodedUserCookie = window.atob(userCookie);
            const obj = JSON.parse(decodedUserCookie);
            userId = obj.userId;
            // We URL-encode this string serverside, so we should URL-decode it here.
            userName = decodeURIComponent(obj.userName);
            userHash = obj.hash;
            userType = obj.userType;
            userHasProjectRefundChoices = obj.hasProjectRefundChoices;
            userHasPendingCheckPledges = obj.hasPendingCheckPledges;
            userObj = obj;
        } catch (e) {
            const userCookieSplit = userCookie.split('##');
            if (userCookieSplit.length > 0) {
                userId = userCookieSplit[0];
                userName = userCookieSplit[1];
                userHash = userCookieSplit[3];
                userType = '';
                userObj = { userId, userName, userHash };
            }
        }

        // avoid rewriting the visitor cookie while we're in the cart
        if (location.href.toLowerCase().indexOf('cart') === -1) {
            if (userType === 'teacher' || userType === 'donor') {
                createCookie('v', userType, 365);
            }
        }

        // I commented out the following line because unescape is deprecated,
        // and this call should be redundant to decodeURIComponent above.
        // If userNames were double-encoded or we were relying on some legacy behavior of unescape,
        // though, we might need to restore it.
        // If it's 2027 and we haven't had problems with this code, delete this comment block.
        // if (userName != '') userName = unescape(userName);

        if (userName.length > 23) userName = userName.substring(0, 20) + '...';

        const usernameIsEmptyOrJustSpaces = userName == null || trim(userName) === '';
        const usernameIsANumber = !usernameIsEmptyOrJustSpaces && !isNaN(userName);
        if (usernameIsEmptyOrJustSpaces || usernameIsANumber || (qsParam.hasOwnProperty('pmaId') && qsParam.pmaId !== '' && String(userId) !== qsParam.pmaId)) {
            eraseCookie('userId');
            resetUserVariables();
            removeFavorites();
        }
    }

    if (isNonBlankCookie('headerinfo')) {
        const headerinfo = JSON.parse(window.atob(readCookie('headerinfo')));
        if (headerinfo) {
            for (const key in headerinfo) {
                if (headerinfo.hasOwnProperty(key)) {
                    userObj[key] = headerinfo[key];
                }
            }
        }
    }

    $(window).trigger('userCookiesReset');
};

window.isVIPDonor = function () {
    return !!(typeof userObj !== 'undefined' && typeof userObj.isVIP !== 'undefined' && userObj.isVIP);
};

window.isHighValueDonor = function () {
    return !!(typeof userObj !== 'undefined' && userObj.isTTD);
};

window.getUserType = function () {
    if (userObj.userType) {
        return userObj.userType;
    }
    if (readCookie('userType')) {
        return readCookie('userType');
    }
    if (readCookie('v')) {
        return readCookie('v');
    }
    return 'unknown';
};

window.isUserTypeTeacher = function () {
    if (userType != null && userType !== '') return (userType === 'teacher');
    if (readCookie('v') != null) return (readCookie('v') === 'teacher');
    return false;
};

// setUpUserCookies should run before anything else since user data is used in tracking, react components and other javascript code
setUpUserCookies();
// it's duplicative, but  sometimes we want the body set before userCookiesReset is triggered
$(window).on('load', function () { setUpUserCookies(); });
